import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title as UiTitle } from '@/shared/uikit/Title';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-rows: 72px calc(100% - 72px - 92px) 92px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  overflow: hidden;
  border-bottom: 1px solid ${COLORS.systemDark100};
`;

export const Body = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: scroll;
`;

export const Title = styled(UiTitle)`
  max-width: calc(100% - 32px);
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
`;

export const Actions = styled.div`
  padding-inline: 24px;
  border-top: 1px solid ${COLORS.systemDark100};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Info = styled.div`
  height: 64px;
  padding: 14px 12px;
  border-radius: 12px;
  display: flex;
  gap: 8px;
  background: ${COLORS.systemLight200};
`;

export const Name = styled.div`
  margin-top: -2px;
  height: 40px;
  display: grid;
  gap: 4px;
  grid-template-rows: 20px 16px;
`;

export const Textarea = styled.textarea`
  height: 150px;
  padding: 8px 16px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  background: ${COLORS.systemLight200};

  &::placeholder {
    color: ${COLORS.systemDark200};
  }
`;
